import styled from "@emotion/styled"
import { MDBInput } from "mdb-react-ui-kit"
import { useEffect, useState } from "react"

const StyledMDBInput = styled(MDBInput)`
  height: 28px;
  width: 52px;
  padding: 0 7px !important;
  margin: 5px 2px !important; 
`

export const PrecioVentaInput = ({
  row,
  onCommit,
}: {
  row: any
  onCommit: (value: string) => void
}) => {
  const [value, setValue] = useState(row.precioVenta)

  useEffect(() => {
    setValue(row.precioVenta)
  }, [row.precioVenta])

  return (
    <StyledMDBInput
      type="text"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={() => onCommit(value)}
    />
  )
}
